import { membershipApplications } from "../../api/endpoints/tutor-membership/membership";
import TutorModel from "../../api/models/TutorModel";
import ContainerMd from "../../components/Layouts/ContainerMd";
import LogoWithLanguage from "../../components/logo-with-language/LogoWithLanguage";
import UserPersonalInfo from "../../components/personalInfo/UserPersonalInfo";

export default function RequirementForm() {
  const afterSubmit = () => {
    // history.go(0);
  };

  return (
    <ContainerMd>
      <LogoWithLanguage />
      <div className="flex h-fit flex-col bg-gray-50  items-center w-full">
        <UserPersonalInfo
          updateUser={membershipApplications}
          user={new TutorModel({})}
          afterSubmit={afterSubmit}
          isEditable={true}
          isEmailEditable={false}
          stylesClass={"md:bg-white  md:p-6"}
        />
      </div>
    </ContainerMd>
  );
}
